import { ButtonHTMLAttributes, ReactNode } from "react";
import arrowWhite from "../assets/arrow-white.svg";
import arrowBlack from "../assets/arrow-black.svg";

type Variant = "filled" | "outline-light" | "outline-dark";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  children: ReactNode;
};

const variantStyles: Record<Variant, string> = {
  filled: "bg-kag-red text-white border-0 hover:bg-kag-red-hover",
  "outline-light": "bg-transparent text-white border border-white hover:bg-white/5",
  "outline-dark": "bg-transparent text-black border border-black hover:bg-black/5",
};

export default function Button({
  variant = "filled",
  className = "",
  children,
  ...rest
}: Props) {
  const arrow = variant === "outline-dark" ? arrowBlack : arrowWhite;
  return (
    <button
      className={`inline-flex items-center justify-center min-w-[180px] h-[48px] px-[28px] gap-[18px] rounded-[8px] font-clash font-semibold uppercase tracking-[0.02em] text-[14px] whitespace-nowrap transition-colors ${variantStyles[variant]} ${className}`}
      {...rest}
    >
      <span>{children}</span>
      <img src={arrow} alt="" aria-hidden="true" className="block w-[14px] h-[12px]" />
    </button>
  );
}
